import { ThemeProvider } from '@common/styles/theme-provider';
import { wrapEnvConfigContext } from '@domains/storehome-common';
import { getStoreHomePageServerSideProps, StoreHomePage, StoreHomePageProps } from '@domains/storehome-screen';

const StoreHomePageWrapper = (props: StoreHomePageProps) => {
  return (
    <ThemeProvider colorScheme='light'>
      <StoreHomePage {...props} />
    </ThemeProvider>
  );
};

export default wrapEnvConfigContext({ is_zigzag: true }, StoreHomePageWrapper);
export const getServerSideProps = getStoreHomePageServerSideProps;
